import appContractorInvoiceItem from "../../views/appCustomers/contractorInvoiceItem.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("contractorinvoiceitem", {
    url: "contractor-invoice-item/:id",
    parent: "app",
    views: {
      view: {
        template: appContractorInvoiceItem,
      },
    },
    reloadOnSearch: false,
    data: { title: "ContractorInvoiceItem" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/contractorInvoiceItem/contractorInvoiceItem.urls.js